import View from './view';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../redux/selectors/resources';
import {useNavigation} from '@react-navigation/native';
import {holderProfileSelector} from '../../redux/selectors/profile';
import {Screens} from '../../shared/routing/model';
import {UscType} from '../../shared/models/profile/uscType';

export const BankServicesScreen = () => {
  const navigation = useNavigation();
  const content = useSelector(contentSelector());
  const holderProfile = useSelector(holderProfileSelector());

  if (holderProfile && holderProfile.uscType !== UscType.Financial) {
    navigation.navigate(Screens.Main);
  }

  return View({
    content,
  });
};
